import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ServicesHero from "./components/ServicesHero";
import ServicesList from "./components/ServicesList";
import { BOOKING_URL } from "@/config/site";

export default function Services() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ServicesHero />
        <ServicesList />

        {/* Bottom CTA */}
        <section className="bg-[#f5f0e8] py-20">
          <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
            <p className="text-[#9a9a9a] text-xs font-medium tracking-widest uppercase mb-4">Ready to Begin?</p>
            <h2 className="text-3xl md:text-4xl font-light text-[#2d2d2d] mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
              The first step is the<br />
              <span className="italic font-semibold">hardest one.</span>
            </h2>
            <p className="text-[#6b6b6b] text-sm leading-relaxed mb-8 max-w-lg mx-auto">
              You don't need to have everything figured out before reaching out. A free 20-minute consultation is a low-pressure way to see if we're a good fit.
            </p>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#7a9e7e] hover:bg-[#6a8e6e] text-white font-medium px-8 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              Schedule a Free Consultation
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
